import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-8208632e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "field-row" };
const _hoisted_2 = { class: "field" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "name" }, "Nombre completo", -1));
const _hoisted_4 = ["aria-invalid", "aria-describedby"];
const _hoisted_5 = {
    key: 0,
    id: "name-error",
    class: "field-error"
};
const _hoisted_6 = { class: "field" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "phone" }, "Teléfono", -1));
const _hoisted_8 = ["aria-invalid", "aria-describedby"];
const _hoisted_9 = {
    key: 0,
    id: "phone-error",
    class: "field-error"
};
const _hoisted_10 = { class: "field" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "email" }, "Correo electrónico", -1));
const _hoisted_12 = ["aria-invalid", "aria-describedby"];
const _hoisted_13 = {
    key: 0,
    id: "email-error",
    class: "field-error"
};
const _hoisted_14 = { class: "field" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "message" }, "¿Qué necesitás resolver?", -1));
const _hoisted_16 = ["aria-invalid", "aria-describedby"];
const _hoisted_17 = {
    key: 0,
    id: "message-error",
    class: "field-error"
};
const _hoisted_18 = ["disabled"];
const _hoisted_19 = {
    key: 0,
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true"
};
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("path", {
    d: "M4 6.75A1.75 1.75 0 0 1 5.75 5h12.5A1.75 1.75 0 0 1 20 6.75v10.5A1.75 1.75 0 0 1 18.25 19H5.75A1.75 1.75 0 0 1 4 17.25V6.75Z",
    stroke: "currentColor",
    "stroke-width": "1.5"
}, null, -1));
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("path", {
    d: "m5 7 7 5 7-5",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
}, null, -1));
const _hoisted_22 = [
    _hoisted_20,
    _hoisted_21
];
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "privacy-note" }, "Tus datos se usan únicamente para responder esta consulta.", -1));
import { reactive, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ContactForm',
    setup(__props) {
        const form = reactive({ name: '', email: '', phone: '', message: '' });
        const errors = reactive({ name: '', email: '', phone: '', message: '' });
        const status = reactive({ type: '', message: '' });
        const submitting = ref(false);
        const validateName = () => {
            const value = form.name.trim();
            errors.name = value.length < 2 ? 'Ingresá tu nombre completo.' : '';
            return !errors.name;
        };
        const validateEmail = () => {
            errors.email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())
                ? ''
                : 'Ingresá un correo electrónico válido.';
            return !errors.email;
        };
        const validatePhone = () => {
            const digits = form.phone.replace(/\D/g, '');
            errors.phone = digits.length >= 7 && digits.length <= 15
                ? ''
                : 'Ingresá un teléfono válido.';
            return !errors.phone;
        };
        const validateMessage = () => {
            const value = form.message.trim();
            errors.message = value.length >= 10
                ? ''
                : 'Contame un poco más sobre tu consulta.';
            return !errors.message;
        };
        const resetForm = () => {
            form.name = '';
            form.email = '';
            form.phone = '';
            form.message = '';
        };
        const handleSubmit = async () => {
            status.message = '';
            const valid = [validateName(), validateEmail(), validatePhone(), validateMessage()].every(Boolean);
            if (!valid)
                return;
            submitting.value = true;
            try {
                const apiBase = process.env.VUE_APP_API_URL || '';
                const response = await fetch(`${apiBase}/contact_messages`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        name: form.name.trim(),
                        email: form.email.trim(),
                        phone: form.phone.trim(),
                        message: form.message.trim(),
                    }),
                });
                if (!response.ok)
                    throw new Error('Request failed');
                status.type = 'success';
                status.message = 'Gracias. Tu consulta fue enviada por email correctamente.';
                resetForm();
            }
            catch {
                status.type = 'error';
                status.message = 'No pude enviar tu consulta. Por favor, llamame o escribime por WhatsApp.';
            }
            finally {
                submitting.value = false;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", {
                class: "contact-form",
                novalidate: "",
                onSubmit: _withModifiers(handleSubmit, ["prevent"])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _hoisted_3,
                        _withDirectives(_createElementVNode("input", {
                            id: "name",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.name) = $event)),
                            name: "name",
                            type: "text",
                            autocomplete: "name",
                            placeholder: "Tu nombre",
                            "aria-invalid": Boolean(errors.name),
                            "aria-describedby": errors.name ? 'name-error' : undefined,
                            onBlur: validateName
                        }, null, 40, _hoisted_4), [
                            [_vModelText, form.name]
                        ]),
                        (errors.name)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(errors.name), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _withDirectives(_createElementVNode("input", {
                            id: "phone",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.phone) = $event)),
                            name: "phone",
                            type: "tel",
                            autocomplete: "tel",
                            placeholder: "+598 99 123 456",
                            "aria-invalid": Boolean(errors.phone),
                            "aria-describedby": errors.phone ? 'phone-error' : undefined,
                            onBlur: validatePhone
                        }, null, 40, _hoisted_8), [
                            [_vModelText, form.phone]
                        ]),
                        (errors.phone)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(errors.phone), 1))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _withDirectives(_createElementVNode("input", {
                        id: "email",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.email) = $event)),
                        name: "email",
                        type: "email",
                        autocomplete: "email",
                        placeholder: "nombre@correo.com",
                        "aria-invalid": Boolean(errors.email),
                        "aria-describedby": errors.email ? 'email-error' : undefined,
                        onBlur: validateEmail
                    }, null, 40, _hoisted_12), [
                        [_vModelText, form.email]
                    ]),
                    (errors.email)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(errors.email), 1))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _withDirectives(_createElementVNode("textarea", {
                        id: "message",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.message) = $event)),
                        name: "message",
                        rows: "5",
                        placeholder: "Contame brevemente el motivo de tu consulta",
                        "aria-invalid": Boolean(errors.message),
                        "aria-describedby": errors.message ? 'message-error' : undefined,
                        onBlur: validateMessage
                    }, null, 40, _hoisted_16), [
                        [_vModelText, form.message]
                    ]),
                    (errors.message)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(errors.message), 1))
                        : _createCommentVNode("", true)
                ]),
                (status.message)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["form-status", { 'form-status--success': status.type === 'success' }]),
                        role: "status"
                    }, _toDisplayString(status.message), 3))
                    : _createCommentVNode("", true),
                _createElementVNode("button", {
                    type: "submit",
                    disabled: submitting.value
                }, [
                    _createElementVNode("span", null, _toDisplayString(submitting.value ? 'Enviando email…' : 'Enviar por email'), 1),
                    (!submitting.value)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_22))
                        : _createCommentVNode("", true)
                ], 8, _hoisted_18),
                _hoisted_23
            ], 32));
        };
    }
});
